import { React } from 'react';
import { useNavigate } from 'react-router-dom';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { useSelector } from 'react-redux';

export const BreadcrumbComponent = () => {
  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const navigate = useNavigate();

  const routes = [{ path: '/', breadcrumb: dictionary.main }];

  const breadcrumbs = useBreadcrumbs(routes);

  return (
    <Breadcrumb>
      {breadcrumbs.map(({ match, breadcrumb }) => {
        if (window.location.pathname === match.pathname) {
          return (
            <Breadcrumb.Item
              key={Math.random()}
              active
              to={`${match.pathname}`}
              href=""
              onClick={() => navigate(`${match.pathname}`)}
            >
              {
                dictionary[
                  breadcrumb.props.children
                    .toLowerCase()
                    .replaceAll('-', '_')
                    .replaceAll('/', '')
                    .replaceAll(' ', '_')
                ]
              }
            </Breadcrumb.Item>
          );
        } else {
          return (
            <Breadcrumb.Item
              key={Math.random()}
              to={`${match.pathname}`}
              href=""
              onClick={() => navigate(`${match.pathname}`)}
            >
              {breadcrumb.key === '/'
                ? breadcrumb
                : dictionary[
                  breadcrumb.key
                    .toLowerCase()
                    .replaceAll('-', '_')
                    .replaceAll('/', '')
                ]}
            </Breadcrumb.Item>
          );
        }
      })}
    </Breadcrumb>
  );
};

export { BreadcrumbComponent as Breadcrumb };
